export default __webpack_public_path__ + "static/media/start-banner-v5-mobile.6f09b66f.svg";